<template>
  <div class="menu w-32">
    <div class="row-actions">
      <template v-for="action in actions">
        <a
          class="menu-action menu-item menu-link hover:bg-blue-600 hover:text-gray-100 rounded-md"
          v-if="canDo(action)"
          @click="$emit(action, item)"
        >
          <span :class="['action-' + action]">{{ capitalize(action) }}</span>
        </a>
      </template>
    </div>
  </div>
</template>

<script>
import capitalize from '@/Filters/Capitalize'

export default {
  props: {
    actions: {
      type: Array,
      default() {
        return []
      }
    },

    can: {
      type: Array,
      default() {
        return []
      }
    }
  },

  methods: {
    capitalize,

    /**
     * Determines whether an action should be displayed in the menu
     * @param action
     * @return boolean
     */
    canDo(action) {
      /**
       * If :can prop is empty, we always return true.
       * Otherwise, we return true if action is included in :can prop
       */
      if (this.can.length === 0) {
        return true
      }

      return this.can.includes(action)
    }
  }
}
</script>
